export default function EditButton(props) {
  return (
    <button onClick={props.handleClick} class="max-w-[70px] h-max self-start py-1 px-5 gap-1.5 rounded-sm bg-[#FF6633]  text-base font-normal leading-6 text-center text-white">
      Edit
    </button>
  )
}